var createReactClass = require('create-react-class');
import React from 'react';
import PropTypes from 'prop-types';

const Title = createReactClass({
  propTypes: {
    htmlBody: PropTypes.shape({
      correct: PropTypes.arrayOf(PropTypes.string),
      incorrect: PropTypes.arrayOf(PropTypes.string)
    })
  },

  renderCorrectTitles: function() {
    return this.props.htmlBody.correct.map((title, index) => (
      <p key={`correct-${index}`}>
        <i className="far fa-check-circle good"/>
        &nbsp;Correct: {title}
      </p>
    ));
  },

  renderIncorrectTitles: function() {
    return this.props.htmlBody.incorrect.map((title, index) => (
      <p key={`incorrect-${index}`}>
        <i className="fa fa-times-circle bad"/>
        &nbsp;Incorrect: {title}
      </p>
    ));
  },

  render: function() {
    return (
      <div>
        <h4 className="reg">How should I format my article title?</h4>
        {this.renderCorrectTitles()}
        {this.renderIncorrectTitles()}
      </div>
    );
  }
});

export default Title;